import type { FunctionComponent } from 'react';

import { useGlobalSearchTableParams } from '../../../global-search/use-global-search-table-params';
import { LearningOpportunitiesBySearchTermTable } from './LearningOpportunitiesBySearchTermTable';
import { LearningOpportunitiesBySkillTable } from './LearningOpportunitiesBySkillTable';

export const LearningOpportunitiesTable: FunctionComponent = () => {
    const { isValidSearchTerm, isValidSkillIdsList, searchTermResult, skillIds } = useGlobalSearchTableParams();

    if (isValidSearchTerm) {
        return <LearningOpportunitiesBySearchTermTable searchTerm={searchTermResult} />;
    }

    if (isValidSkillIdsList) {
        return <LearningOpportunitiesBySkillTable skillIds={skillIds} />;
    }

    return null;
};
